import { render, staticRenderFns } from "./firmwareList.vue?vue&type=template&id=f21d7b5e&scoped=true&"
import script from "./firmwareList.vue?vue&type=script&lang=js&"
export * from "./firmwareList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f21d7b5e",
  null
  
)

export default component.exports